export enum ApiTagsEnum {
    AUTH = "AUTH",
    GAMES = "GAMES",
    WALLET = "WALLET",
}
